import flatpickr from 'flatpickr';
import German from 'flatpickr/dist/l10n/de.js';

// DATE PICKERS

let numberOfNights = null;

function initFlatPickr() {
    // Save number of nights in package
    const numberOfNightsEl = document.querySelector('#inquiryFormHotel [data-nights]');
    if (numberOfNightsEl) {
        numberOfNights = numberOfNightsEl.getAttribute('data-nights');
        if (numberOfNights == '') {
            numberOfNights = null;
        } else {
            numberOfNights = parseInt(numberOfNights, 10);
        }
    }

    const arrivalInput = document.querySelector('#inquiryFormHotel-arrivalDate');
    const alternativeArrivalInput = document.querySelector('#inquiryFormHotel-alternativeArrivalDate');
    const departureInput = document.querySelector('#inquiryFormHotel-departureDate');
    const alternativeDepartureInput = document.querySelector('#inquiryFormHotel-alternativeDepartureDate');

    if (!arrivalInput || !departureInput || !alternativeArrivalInput || !alternativeDepartureInput) {
        return;
    }

    if (numberOfNights) {
        let inputPlaceholderSingle = document.querySelector('#inquiryFormHotel #nightsLabelSingle');
        let inputPlaceholderMulti = document.querySelector('#inquiryFormHotel #nightsLabelMulti');
        if (inputPlaceholderSingle && inputPlaceholderMulti) {
            inputPlaceholderSingle = inputPlaceholderSingle.innerHTML;
            inputPlaceholderMulti = inputPlaceholderMulti.innerHTML;
            const inputPlaceholder = numberOfNights == 1 ? inputPlaceholderSingle : inputPlaceholderMulti;
            departureInput.setAttribute('placeholder', inputPlaceholder);
            alternativeDepartureInput.setAttribute('placeholder', inputPlaceholder);
        }

        departureInput.parentElement.classList.add('automatically-filled');
        departureInput.setAttribute('tabindex', '-1');
        alternativeDepartureInput.parentElement.classList.add('automatically-filled');
        alternativeDepartureInput.setAttribute('tabindex', '-1');
    }

    let minDepartureDate = arrivalInput.value ? new Date(arrivalInput.value) : null;

    const commonOptions = {
        // today + 1 day
        minDate: new Date().fp_incr(1),
        altFormat: 'd. m. Y',
        altInput: true,
        locale: document.documentElement.lang || 'en',
        // we need this for HTML 5 validation
        // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
        allowInput: true
    };

    const arrivalFlatPickr = flatpickr(arrivalInput, commonOptions);
    const alternativeArrivalFlatPickr = flatpickr(alternativeArrivalInput, commonOptions);
    const departureFlatPickr = flatpickr(departureInput, commonOptions);
    const alternativeDepartureFlatPickr = flatpickr(alternativeDepartureInput, commonOptions);

    if (minDepartureDate instanceof Date) {
        departureFlatPickr.config.minDate = minDepartureDate;
        alternativeDepartureFlatPickr.config.minDate = minDepartureDate;
    }

    arrivalFlatPickr.config.onChange.push(selectedDates => {
        if (selectedDates.length > 0) {
            minDepartureDate = selectedDates[0];
        }

        if (minDepartureDate instanceof Date) {
            departureFlatPickr.config.minDate = minDepartureDate;
            if (numberOfNights) {
                departureFlatPickr.setDate(minDepartureDate.fp_incr(numberOfNights));
            }
        }
    });

    alternativeArrivalFlatPickr.config.onChange.push(selectedDates => {
        if (selectedDates.length > 0) {
            minDepartureDate = selectedDates[0];
        }

        if (minDepartureDate instanceof Date) {
            alternativeDepartureFlatPickr.config.minDate = minDepartureDate;
            if (numberOfNights) {
                alternativeDepartureFlatPickr.setDate(minDepartureDate.fp_incr(numberOfNights));
            }
        }
    });

    // we need this for HTML 5 validation
    // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
    arrivalInput.nextElementSibling.onkeypress = () => false;
    alternativeArrivalInput.nextElementSibling.onkeypress = () => false;
    departureInput.nextElementSibling.onkeypress = () => false;
    alternativeDepartureInput.nextElementSibling.onkeypress = () => false;
}

initFlatPickr();

// CHILD AGE FIELDS

function showChildAgeFields() {
    const childAgeFields = document.querySelectorAll('.js-child-age');
    const childField = document.querySelector('.js-children');

    if (!childAgeFields || !childField) {
        return;
    }
    function removeFields() {
        const childFieldValue = parseInt(childField.value);
        if (childFieldValue && childFieldValue > 0) {
            document.querySelector('.form-heading--ages').style.display = 'block';
        } else {
            document.querySelector('.form-heading--ages').style.display = 'none';
        }

        [...childAgeFields].forEach((childAgeField, index) => {
            if (index > childFieldValue - 1 || !childFieldValue) {
                childAgeField.classList.add('input--hidden');
                childAgeField.querySelector('input').required = false;
                childAgeField.querySelector('input').value = '';
            } else {
                childAgeField.classList.remove('input--hidden');
                childAgeField.querySelector('input').required = true;
            }
        });
    }

    removeFields();

    childField.addEventListener('input', removeFields);
}

showChildAgeFields();

// ROOM SELECTOR

function insertRoomPictures() {
    let roomImages = [];

    // 1. Select first option per default
    const defaultInput = document.querySelector('#inquiryFormHotel-room li:first-child input');
    if (defaultInput) {
        defaultInput.checked = true;
    }

    // 2. save images in array
    const container = document.querySelector('#room-images');
    if (container) {
        const images = container.querySelectorAll('img');
        [...images].forEach(img => {
            roomImages[img.getAttribute('data-for')] = img.getAttribute('src');
        });
    }

    // 3. insert images
    const inputs = document.querySelectorAll('.room-selector input');
    [...inputs].forEach(input => {
        let imgEl = document.createElement('img');
        let src = roomImages[input.getAttribute('value')];
        if (src) {
            imgEl.setAttribute('src', src);
            input.parentNode.insertBefore(imgEl, input.nextSibling);
        }
    });
}

insertRoomPictures();

// Address fields are required when wantsBrochure is checked

const brochureCheckbox = document.querySelector('[type="checkbox"][name="--inquiryFormHotel[wantsBrochure]"]');
if (brochureCheckbox) {
    brochureCheckbox.addEventListener('change', function() {
        const addressFields = document.querySelectorAll(
            'label[for="inquiryFormHotel-street"],label[for="inquiryFormHotel-houseNumber"],label[for="inquiryFormHotel-postCode"],label[for="inquiryFormHotel-city"],label[for="inquiryFormHotel-country"]'
        );

        [...addressFields].forEach(field => {
            field.parentNode.querySelector('input').required = brochureCheckbox.checked;
            if (brochureCheckbox.checked) {
                field.classList.add('is-required');
            } else {
                field.classList.remove('is-required');
            }
        });
    });
}

// Disable submit button once it's clicked
const form = document.querySelector('.form');
if (form) {
    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
        form.addEventListener('submit', () => {
            submitButton.classList.add('clicked');
        });
    }
}

// Spam Protection

function addEvents() {
    document.addEventListener('touchstart', insertSpamProtectionValue, true);
    document.addEventListener('keydown', insertSpamProtectionValue, true);
    document.addEventListener('mousemove', insertSpamProtectionValue, true);
    document.addEventListener('touchmove', insertSpamProtectionValue, true);
}

function removeEvents() {
    document.removeEventListener('touchstart', insertSpamProtectionValue, true);
    document.removeEventListener('keydown', insertSpamProtectionValue, true);
    document.removeEventListener('mousemove', insertSpamProtectionValue, true);
    document.removeEventListener('touchmove', insertSpamProtectionValue, true);
}

function insertSpamProtectionValue() {
    const fields = document.querySelectorAll('.js-spam-protection-field');
    [...fields].forEach(field => {
        const form = field.closest('form');

        if (!form) {
            return;
        }

        const stateField = form.querySelector('input[name*=__state');

        if (stateField) {
            field.value = stateField.value;
        }
    });

    removeEvents();
}

if (document.querySelectorAll('.js-spam-protection-field').length > 0) {
    addEvents();
}
